<div class="body">
  <i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
  <div class="test">
    <div class="row column-one">
      <div class="content-wrapper">
        <div class="dialog-title">
          <img
            style="margin-right: 5px"
            width="24"
            height="24"
            src="/assets/img/icons/cyborg-premium.png"
          />
          Hunt Module
        </div>
        <p>
          Want to learn more? Connect with us today to explore the Hunt Module
          features, accessible only to Premium subscribers.
        </p>
        <ul>
          <li>
            Offer a space for teams to plan, execute, manage, and report on
            hunts.
          </li>
          <li>
            Generate detailed reports providing stakeholders with valuable
            insights.
          </li>
          <li>
            Develop structured templates to streamline the initiation,
            customization, and execution of future hunts.
          </li>
          <li>
            Gain clarity on the business impact of threat hunting activities by
            tracking hunt KPIs and Metrics.
          </li>
          <li>Full API access included.</li>
        </ul>
        <cyborg-button (click)="talkToCyborg()" color="primary">
          Talk to an Intel 471 Expert</cyborg-button
        >
      </div>
      <video
        loop
        controls
        oncanplay="this.play()"
        onloadedmetadata="this.muted = true"
      >
        <source
          src="https://go.intel471.com/hubfs/HUNTER%20Platform/Hunter%20Management%20Module.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</div>
